// extracted by mini-css-extract-plugin
export default {"_group":"otp-input__group__zwBGu","_otp-input":"otp-input__otp-input__SFsqj","input-focus":"otp-input_input-focus__f6Sq3"};